var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemRedditShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Reddit share arrow icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.8 3.6v3c-8.4 1.2-12 6-13.2 12 3-4.2 7.2-6 13.2-6v3.6l7.2-6z"
})));
export default SvgGemRedditShare;